// 排序模式
export enum SortMode {
  // 数值排序
  Number = 0,
  // 环比排序
  Ratio = 1,
}

// 排序模式列表（全量）
export const SortModes = Object.values(SortMode);

// 排序方式
export enum SortType {
  // 升序
  Asc = 'asc',
  // 降序
  Desc = 'desc',
  // 不排序
  None = '',
}
